import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { Props } from "./types";
import { FolderSelection } from "./folderSelection";
import styles from "./styles.scss";

function Form({
  namespace,
  type,
  formData,
  parentFolder,
  rootName,
  edit,
  selectParentFolder,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("folderCreation.nameTitle")}</h3>
        <TextInput
          className={styles.name}
          value={formData.name}
          placeholder={t("folderCreation.namePlaceholder")}
          input={(name) => edit({ ...formData, name })}
          autoFocus
        />
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>
          {t("folderCreation.parentFolderTitle")}
        </h3>
        <div className={styles.folderSelection}>
          <FolderSelection
            namespace={namespace}
            type={type}
            selectedFolder={parentFolder}
            rootName={rootName}
            placeholder={t("folderCreation.parentFolderPlaceholder")}
            select={selectParentFolder}
          />
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("folderCreation.descriptionTitle")}</h3>
        <TextInput
          className={styles.description}
          value={formData.description}
          placeholder={t("folderCreation.descriptionPlaceholder")}
          input={(description) => edit({ ...formData, description })}
          isMultiline
        />
      </div>
    </div>
  );
}

export { Form };
